import React from 'react'

import { CurrencyAreaContext } from './CurrencyAreaContext'
import { CurrencyAreaOutputDto, CurrencyEnum } from '../../../lib/graphql'
import { multiplyByFactor } from '../../../utils/prices'

const DEFAULT_CURRENCY_AREA = {
  currency: CurrencyEnum.EUR,
  vatRates: [
    0,
    multiplyByFactor(5.5),
    multiplyByFactor(10),
    multiplyByFactor(20),
  ],
  multiVatRates: [[multiplyByFactor(10), multiplyByFactor(20)]],
}

type CurrencyAreaContextProviderProps = {
  children: React.ReactNode
  context: {
    currencyArea?: CurrencyAreaOutputDto
  }
}

export const CurrencyAreaContextProvider = ({
  children,
  context,
}: CurrencyAreaContextProviderProps) => {
  return (
    <CurrencyAreaContext.Provider
      value={{ currencyArea: context.currencyArea ?? DEFAULT_CURRENCY_AREA }}
    >
      {children}
    </CurrencyAreaContext.Provider>
  )
}
